module.exports = __webpack_public_path__ + "img/2.5d_2.1f0573be.jpg";